import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b001016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-chart__content" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_line_chart = _resolveComponent("line-chart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'periodontal-chart--interactive': _ctx.isInteractive,
      'periodontal-chart--preview': _ctx.isPreviewMode,
    }, "periodontal-chart"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([{
          'periodontal-chart__teeth--down': _ctx.isReverse,
          'periodontal-chart__teeth--preview': _ctx.isPreviewMode,
          'periodontal-chart__teeth--pdf': _ctx.isPdfMode,
          'periodontal-chart__teeth--interactive': _ctx.isInteractive,
        }, "periodontal-chart__teeth"])
      }, [
        (_ctx.isPreviewMode || _ctx.isPdfMode)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.teethList, (tooth, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{
              'periodontal-chart__tooth-wrapper--reverse': !_ctx.isUpperTeeth,
            }, "periodontal-chart__tooth-wrapper periodontal-chart__tooth-wrapper--preview"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                'periodontal-chart__tooth--removed': _ctx.checkIsToothRemoved(
                  tooth.id
                ),
              }, "periodontal-chart__tooth periodontal-chart__tooth--preview"]),
                  innerHTML: _ctx.checkIsImplant(tooth.id) ? tooth.implantSvg : tooth.svg
                }, null, 10, _hoisted_2)
              ], 2))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.teethList, (tooth, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{
              'periodontal-chart__tooth-wrapper--interactive': _ctx.isInteractive,
              'periodontal-chart__tooth-wrapper--reverse': !_ctx.isUpperTeeth,
            }, "periodontal-chart__tooth-wrapper"])
              }, [
                _createVNode(_component_icon_template, {
                  class: _normalizeClass([{
                'periodontal-chart__tooth--removed': _ctx.checkIsToothRemoved(
                  tooth.id
                ),
              }, "periodontal-chart__tooth"]),
                  height: _ctx.getToothHeight(tooth),
                  name: _ctx.checkIsImplant(tooth.id) ? tooth.implantName : tooth.name,
                  width: _ctx.getToothWidth(tooth)
                }, null, 8, ["class", "height", "name", "width"])
              ], 2))
            }), 128))
      ], 2),
      _createVNode(_component_line_chart, _mergeProps({
        class: [{
          'periodontal-chart__chart--reverse': _ctx.isReverse,
          'periodontal-chart__chart--interactive': _ctx.isInteractive,
          'periodontal-chart__chart--preview': _ctx.isPreviewMode,
        }, "periodontal-chart__chart"]
      }, _ctx.lineChartProps), null, 16, ["class"])
    ])
  ], 2))
}